import { render, staticRenderFns } from "./AlertasDetalleGrid.vue?vue&type=template&id=8ee3f570&"
import script from "./AlertasDetalleGrid.vue?vue&type=script&lang=ts&"
export * from "./AlertasDetalleGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports